module.exports = __webpack_public_path__ + "img/edit-round.18c914b4.png";